import React, { ReactElement } from 'react';
import styled from 'styled-components';

interface ToggleButtonsProps {
  active?: number;
  onSelect?: (index: number) => void;
  children?: ReactElement | ReactElement[];
}

const StyledToggleButtonsContainer = styled.div`
  display: inline-flex;
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colors.BORDER};
  overflow: hidden;
`;
const StyledToggleButton = styled.div<{ isActive: boolean; disabled: boolean }>`
  display: flex;
  padding: 6px;
  color: ${({ theme, isActive }) => (isActive ? theme.colors.CARD : 'inherit')};
  background: ${({ theme, isActive }) =>
    isActive ? theme.colors.BLUE.B400 : theme.colors.BLUE.B50};
  cursor: pointer;
  ${({ disabled }) =>
    disabled &&
    `
    pointer-events: none;
    opacity: .5;
  `}
`;

const ToggleButtonsComponent = ({
  children,
  active,
  onSelect,
}: ToggleButtonsProps) => {
  const icons = children
    ? Array.isArray(children)
      ? children
      : [children]
    : [];

  return (
    <StyledToggleButtonsContainer>
      {icons.map((icon, index) => (
        <StyledToggleButton
          key={index}
          isActive={active === index}
          onClick={() => onSelect && onSelect(index)}
          disabled={icon.props.disabled}
        >
          {icon}
        </StyledToggleButton>
      ))}
    </StyledToggleButtonsContainer>
  );
};

export default ToggleButtonsComponent;
